import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Coupon Service
 * Handles all discount coupon-related API calls
 */
const couponService = {
  getAllCoupons: async () => {
    const response = await apiClient.post(API_ENDPOINTS.COUPON.GET_ALL);
    return response.data;
  },

  addCoupon: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.COUPON.ADD, data);
    return response.data;
  },

  updateCoupon: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.COUPON.UPDATE, data);
    return response.data;
  },

  deleteCoupon: async (couponId) => {
    const response = await apiClient.post(API_ENDPOINTS.COUPON.DELETE, { couponId });
    return response.data;
  },
};

export default couponService;

